import React from 'react';
import { Wrapper } from './feedback-request-status-badge.styles';
import { FeedbackRequestStatusBadgeProps } from './types';
import { Typography } from '@shared/ui/typography/typography';
import { FEEDBACK_REQUEST_TEXT_STATUS_MAP } from '@entities/feedback-request/config/ui-constants';

export const FeedbackRequestStatusBadge: React.FC<FeedbackRequestStatusBadgeProps> = ({ status }) => {
    return (
        <Wrapper $status={status}>
            <Typography size='body2_short' color='inherit'>
                {FEEDBACK_REQUEST_TEXT_STATUS_MAP[status]}
            </Typography>
        </Wrapper>
    );
};
